import { Money } from '../components/MoneyView';

interface PartialMoneyV2 {
  value: string;
  currency: { code: string };
}

export function mapMoneyV2ToMoney(amount: PartialMoneyV2 | null | undefined): Money | undefined {
  if (!amount) {
    return;
  }
  return {
    value: +amount.value,
    currency: amount.currency.code,
  };
}
